import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function RootRedirect() {
  const { user, isLoading } = useAuth()

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary-500/30 border-t-primary-500 rounded-full animate-spin" />
      </div>
    )
  }

  // Redirect based on authentication status
  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
}